import React from 'react';
import { utils } from 'kb-shared';
import AppointmentDetail from './AppointmentDetail';
import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';

const { isPregnancyTest, appointmentTypes } = utils;

const journeyTypeQuery = gql`
  query journeyType {
    journeyType
  }
`;

const PregnancyTestDetail = () => {
  const { data } = useQuery(journeyTypeQuery);
  const journeyType = data?.journeyType;

  return (
    <AppointmentDetail
      apptTypeId={Number(appointmentTypes(process.env.REACT_APP_ENV).PREGNANCY)}
      appointmentFilter={isPregnancyTest}
      description={
        <p>
          {journeyType === 'TIMED INTERCOURSE'
            ? "This is a blood test that will indicate whether you are pregnant. You should schedule this about 2 weeks after the IUI. We're rooting for you! If you're not pregnant, we are here for you to discuss further options."
            : "This is a blood test that will indicate whether you are pregnant. We're rooting for you! If it didn't stick, we are here for you to discuss further options."}
        </p>
      }
    />
  );
};

export default PregnancyTestDetail;
